module.exports = __webpack_public_path__ + "static/media/customer-bkcafe.4ec040be.png";